<template>
    <div class="replay">
        <div v-for="(item, index) in replayData" :key="index" class="replay-item">
            <h3 class="date-week flex flex-vertical-center">
                <p class="date">{{ date(index) }}</p>
                <p class="week">{{ week(index) }}</p>
            </h3>
            <div v-for="(option, i) in item" :key="i" class="lesson-container">
                <div class="lesson-item">
                    <div class="lesson-content flex flex-between">
                        <div class="lesson-content-left">
                            <h3 class="lesson-title">{{ option.name }}</h3>
                            <p class="lesson-teacher">
                                {{
                                    `授课老师：${option.teacher_name} / 科目：【${option.subject_name}】`
                                }}
                            </p>
                            <span
                                v-if="option.file"
                                class="download"
                                @click="handleDownload(option.id)"
                                >资料下载</span
                            >
                        </div>
                        <div class="lesson-content-right flex flex-vertical-center">
                            <hk-button
                                v-if="option.work_id && !option.work_status"
                                text="做作业"
                                :customStyle="testButton"
                                @handleClick="toTest(option.id)"
                            ></hk-button>
                            <hk-button
                                v-if="option.work_id && option.work_status"
                                text="作业解析"
                                :customStyle="analysisButton"
                                @handleClick="toAnalysis(option.id)"
                            ></hk-button>
                            <hk-button
                                text="开始回看"
                                :customStyle="replayButton"
                                @handleClick="handleWatch(option.id)"
                            ></hk-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HkButton from '@components/HkButton';
import moment from '@plugins/_moment';
import { downloadResource } from '@api/liveList';
export default {
    components: {
        HkButton
    },
    props: {
        replayData: {
            require: true,
            type: Object
        }
    },
    data() {
        return {
            testButton: {
                width: '110px',
                color: '#fff',
                shadowColor: '#D695DE',
                background: true,
                startColor: '#A90FBC',
                endColor: '#CA2AD0'
            },
            analysisButton: {
                width: '110px',
                color: '#6D33B3',
                border: '1px solid #6D33B3',
                shadowColor: 'transparent',
                background: true,
                startColor: 'transparent',
                endColor: 'transparent'
            },
            replayButton: {
                width: '110px',
                color: '#fff',
                shadowColor: '#FFC8A4',
                background: true,
                startColor: '#FF7B1A',
                endColor: '#FFA11A'
            }
        };
    },
    created() {},
    mounted() {},
    methods: {
        date(time) {
            return moment(time).format('MM月DD日');
        },
        week(time) {
            return moment(time).format('dddd');
        },
        handleWatch(id) {
            this.$trackEvent('视频回放', '进入视频回放', id);
            this.$router.push({ name: 'PlaybackPlayer', query: { id } });
        },
        async handleDownload(id) {
            const { data } = await downloadResource(id);
            this.$trackEvent('资料', '下载资料');
            window.open(data, '_blank');
        },
        toTest(id) {
            this.$trackEvent('答题', '开始做题', id);
            this.$router.push({ name: 'Test', query: { scheduleId: id } });
        },
        toAnalysis(id) {
            this.$trackEvent('答题', '解析', id);
            this.$router.push({ name: 'Analysis', query: { scheduleId: id } });
        }
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.replay-item {
    width: 100%;
    .date-week {
        margin-bottom: 13px;
        p {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333;
        }
        .date {
            margin-right: 30px;
        }
    }
    .lesson-container {
        box-sizing: border-box;
        padding-left: 129px;
        .lesson-item {
            padding-left: 12px;
            border-left: 1px solid #e5e5e5;
            .lesson-content {
                box-sizing: border-box;
                width: 100%;
                background: #f9f9f9;
                border-radius: 20px;
                padding: 20px 20px 20px 36px;
                margin-bottom: 30px;
                align-items: flex-start;
                &-left {
                    .lesson-title {
                        font-size: 16px;
                        font-family: PingFang SC;
                        font-weight: 800;
                        color: #333;
                        margin-bottom: 14px;
                    }
                    .lesson-teacher {
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #666;
                        margin-bottom: 14px;
                    }
                    .download {
                        text-decoration: none;
                        padding-right: 22px;
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        cursor: pointer;
                        color: #7d0f83;
                        background: url('~@images/base/download-icon.png') no-repeat right center;
                    }
                }
                &-right {
                    .hk-button {
                        margin-left: 10px;
                    }
                }
            }
        }
    }
}
</style>
